import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute } from "@angular/router";
import { CommonFunctionService } from "./../../../services/Common/common-function.service";
import { UserMerchantData } from "./../../../services/Common/common-function.service";
import { PayoutService } from 'src/app/services/payout.service';
@Component({
  selector: 'app-view-customer-virtual-account',
  templateUrl: './view-customer-virtual-account.component.html',
  styleUrls: ['./view-customer-virtual-account.component.scss']
})
export class ViewCustomerVirtualAccountComponent implements OnInit {
  rows;
  viewid:any;
  fltrMerchantkeyId:any;
  constructor(private route: ActivatedRoute,private service: PayoutService, private commonfunction: CommonFunctionService) {
    this.route.params.subscribe(params => {
      this.viewid = params['Id'];
    });
   
   let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
   this.fltrMerchantkeyId = merchantdata.MerchantKeyId;
   this.service.ViewCustomerVirtualAccounDetails(this.viewid, merchantdata.MerchantKeyId).subscribe(result => {
    this.rows=result;
    if(this.rows.EmailNotification==1)
    {
      this.rows.EmailNotification="Yes"
    }
    else{
      this.rows.EmailNotification="No"
    }
    if(this.rows.MobileNotification==1)
    {
      this.rows.MobileNotification="Yes"
    }
    else{
      this.rows.MobileNotification="No"
    }
    if(this.rows.BankCodeType==0)
    {
      this.rows.BankCodeType="RoutingTransitNumber"
    }
    else if(this.rows.BankCodeType==1)
    {
      this.rows.BankCodeType="BankSortCodes"
    }
    else if(this.rows.BankCodeType==2)
    {
      this.rows.BankCodeType="BsbNumbers"
    }
    else if(this.rows.BankCodeType==3)
    {
      this.rows.BankCodeType="SwiftCode"
    }
    else if(this.rows.BankCodeType==4)
    {
      this.rows.BankCodeType="MicrCode"
    }
    else if(this.rows.BankCodeType==5)
    {
      this.rows.BankCodeType="IfscCode"
    }
   })
  }

  ngOnInit() {
  }

}
